const home = {
  hu: {
    "Create glass": "Készíts saját plakettet",
    review_title: "Mit írnak nekünk <span>tisztelt ügyfeleink?</span>",
    "Show all": "Az összes",
    "Google review": "Google értékelés megtekintése",
    services_1: "<strong>Ingyenes kiszállítás</strong> 21 000 ft fölött!",
    services_2: "<strong>Több mint 8500</strong> elégedett vásárlónk van.",
    services_3:
      "<strong>Expressz szállítással 24</strong> órán belül küldjük el a csomagot.",
    services_4:
      "<strong>Eredeti</strong> személyre szabott <strong>ajándék</strong>.",

    review_text_1: "„Csodálatosan néz ki élőben!”",
    review_author_1: "Soňa",
    review_text_2:
      "Originálny Darček na Vianoce alebo narodeniny. Plaketa so skla s pesničkou objednaná už viac krát a vždy to vyzerá super! Originálny a osobný darček s ktorým potešíte a prekvapíte hocikoho! Super len tak ďalej",
    review_author_2: "Eva",
    review_text_3:
      "Spotify plaketu so skla s fotografiou sme našli na Instagrame, krásny nápad na darček pre kohokoľvek! Lepší foto darček sme ani nemohli vybrať, ďakujem firme Glassery a odporúčam aj ďalej!",
    review_author_3: "Zdenka",
    review_text_4:
      "Krásny darček! Fotografia bola vytlačená kvalitne, sklo je pekne spracované. Mám z toho dobrý pocit, naozaj originálny foto darček! Ďakujem Vám! :)",
    review_author_4: "Klára",
  },
  sk: {
    "Create glass": "Vytvoriť vlastnú plaketu",
    review_title: "Čo nám píšu naši <span>ctení zákazníci? ♡</span>",
    "Show all": "Zobraziť všetky",
    "Google review": "Google recenzie",
    services_1: "<strong>Doprava zadarmo</strong> pri nákupe nad 60€.",
    services_2: "<strong>Máme viac ako 8500</strong> spokojných zákazníkov.",
    services_3:
      "<strong>S expresným doručením</strong> odosielame do 24 hodín.",
    services_4:
      "<strong>Darček vyrobený na mieru</strong> z prémiových materiálov.",

    review_text_1:
      "Skvelá kvalita sklenenej plakety s pesničkou, milá komunikácia kvalitná tlač a rýchle doručenie. Glassery dávam 10/10 za skvelý servis a krásny darček!!!",
    review_author_1: "Soňa",
    review_text_2:
      "Originálny Darček na Vianoce alebo narodeniny. Plaketa so skla s pesničkou objednaná už viac krát a vždy to vyzerá super! Originálny a osobný darček s ktorým potešíte a prekvapíte hocikoho! Super len tak ďalej",
    review_author_2: "Eva",
    review_text_3:
      "Spotify plaketu so skla s fotografiou sme našli na Instagrame, krásny nápad na darček pre kohokoľvek! Lepší foto darček sme ani nemohli vybrať, ďakujem firme Glassery a odporúčam aj ďalej!",
    review_author_3: "Zdenka",
    review_text_4:
      "Krásny darček! Fotografia bola vytlačená kvalitne, sklo je pekne spracované. Mám z toho dobrý pocit, naozaj originálny foto darček! Ďakujem Vám! :)",
    review_author_4: "Klára",
  },
  cs: {
    "Create glass": "Vytvořit vlastní desku",

    review_title: "Co o nás říkají <span>ctení zákazníci?</span>",
    "Show all": "Zobrazit všechny",
    "Google review": "Google recenze",
    services_1: "<strong>Doprava zdarma</strong> při nákupu nad 1500 Kč.",
    services_2: "<strong>Máme víc jak 8500</strong> nadšených zákazníků.",
    services_3: "<strong>S expresním doručením</strong> odesíláme do 24 hodin.",
    services_4:
      "<strong>Dárek vyrobený na míru</strong> z prémiových materiálů.",

    review_text_1:
      "Skvělá kvalita skleněné desky s písničkou, milá komunikace kvalitní tisk a rychlé doručení. Glassery dávám 10/10 za skvělý servis a krásný dárek!!! ",
    review_author_1: "Soňa",
    review_text_2:
      "Originální Dárek na Vánoce nebo narozeniny. Deska ze skla s písničkou objednaná již vícekrát a vždy to vypadá super! Originální a osobní dárek se kterým potěšíte a překvapíte kohokoli! Super jen tak dál!",
    review_author_2: "Eva",
    review_text_3:
      "Spotify desku se skla s fotografií jsme našli na Instagramu, krásný nápad na dárek pro kohokoli! Lepší foto dárek jsme ani nemohli vybrat, děkuji firmě Glassery a doporučuji!",
    review_author_3: "Zdenka",
    review_text_4:
      "Krásný dárek! Fotografie byla vytištěna kvalitně, sklo je pěkně zpracováno. Mám z toho dobrý pocit, opravdu  originální foto dárek! Děkuji Vám! ",
    review_author_4: "Klára",
  },
};

export default home;
